import { NavigationModal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'

type DeactivatingTeamMemberModalProps = {
  showModal: boolean
  onCancel: () => void
  onConfirm: () => void
  name: string
  carerId: string
}

const DeactivatingTeamMemberModal = ({
  showModal,
  onCancel,
  onConfirm,
  name
}: DeactivatingTeamMemberModalProps) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <NavigationModal
      modalTitle={t('DEACTIVATE_TM_TITLE')}
      modalContentText={t('DEACTIVATE_TM_DESCRIPTION', { name })}
      modalConfirmText={t('OK')}
      modalCancelText={t('CANCEL')}
      showPrompt={showModal}
      confirmNavigation={handleConfirm}
      cancelNavigation={onCancel}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <Text>{t('NO_PAST_INSTANCES_AFFECTED')}</Text>
    </NavigationModal>
  )
}

export default DeactivatingTeamMemberModal
